import React from 'react';
import PropTypes from 'prop-types';
import LMNTheme from './LMN';
import TJHTheme from './TJH';
import LBTheme from './LB';
import TBTTheme from './TBT';
import MLMNTheme from './MLMN';
import MGTTheme from './MGT';

const Theme = props => {
  const themeDict = {
    'lost-my-name': <LMNTheme />,
    'the-journey-home': <TJHTheme />,
    'the-littlest-bear': <LBTheme />,
    'the-birthday-thief': <TBTTheme />,
    'my-little-monster-name': <MLMNTheme />,
    'my-golden-ticket': <MGTTheme />
  };

  return themeDict[props.theme] || null;
};

Theme.propTypes = {
  theme: PropTypes.string.isRequired
};

export default Theme;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/Theme/index.js